import { MaskLine, FadeIn, Overline } from "@/components/motion";
import { CONTACTS } from "@/lib/site";

const SECTIONS = [
  {
    title: "Cosa sono i cookie",
    text: "I cookie sono piccoli file di testo che i siti salvano sul tuo dispositivo per funzionare correttamente o per raccogliere informazioni sull'uso delle pagine. Alcuni sono indispensabili al funzionamento del sito, altri servono a capire come viene utilizzato.",
  },
  {
    title: "Cookie tecnici",
    text: "Questo sito utilizza cookie tecnici, necessari al funzionamento delle pagine e alla sicurezza della navigazione. Non richiedono il tuo consenso e non vengono usati per tracciarti a scopo pubblicitario.",
  },
  {
    title: "Strumenti di analisi",
    text: "Il sito utilizza uno strumento di analisi (PostHog) che raccoglie informazioni aggregate sull'utilizzo delle pagine — ad esempio quali sezioni vengono visitate — per aiutarci a migliorare il servizio. I dati non vengono usati per pubblicità né ceduti a terzi.",
  },
  {
    title: "Nessun cookie di profilazione",
    text: "Non utilizziamo cookie di profilazione, pixel pubblicitari né strumenti di remarketing. La navigazione su questo sito non genera pubblicità personalizzata su altri siti.",
  },
  {
    title: "Come gestire i cookie",
    text: "Puoi cancellare o bloccare i cookie in qualsiasi momento dalle impostazioni del tuo browser. La disattivazione dei cookie tecnici può compromettere il funzionamento di alcune parti del sito.",
  },
  {
    title: "Titolare e contatti",
    text: "Il titolare del trattamento è Synapses S.r.l. STP, con sede legale in Corso Filippo Brunelleschi 173/C, 10141 Torino (TO). Per qualsiasi domanda su cookie e privacy: " + CONTACTS.email + ". Per il trattamento dei dati personali consulta l'informativa privacy.",
  },
];

export default function CookiePolicy() {
  return (
    <>
      <section className="bg-crema pt-40 pb-16 lg:pt-52 lg:pb-20">
        <div className="max-w-4xl mx-auto px-6 lg:px-10">
          <FadeIn>
            <Overline>Cookie policy</Overline>
          </FadeIn>
          <h1 className="mt-8 font-sora font-extrabold tracking-tighter text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-ink" data-testid="cookie-title">
            <MaskLine delay={0.15}>Pochi cookie,</MaskLine>
            <MaskLine delay={0.3}>
              <span className="text-indaco">detto chiaro.</span>
            </MaskLine>
          </h1>
        </div>
      </section>
      <section className="bg-crema pb-28 lg:pb-40">
        <div className="max-w-4xl mx-auto px-6 lg:px-10 space-y-12">
          {SECTIONS.map((s, i) => (
            <FadeIn key={s.title} delay={0.05 * i}>
              <div className="border-t border-viole/20 pt-8" data-testid={`cookie-section-${i}`}>
                <h2 className="font-sora font-bold tracking-tight text-xl text-ink">{s.title}</h2>
                <p className="mt-4 text-[17px] md:text-lg text-viole leading-relaxed">{s.text}</p>
              </div>
            </FadeIn>
          ))}
          <p className="text-sm text-viole/80 italic">
            Ultimo aggiornamento: settembre 2026.
          </p>
        </div>
      </section>
    </>
  );
}
